import { render, staticRenderFns } from "./Costing.vue?vue&type=template&id=0ca01cfe&"
import script from "./Costing.vue?vue&type=script&lang=js&"
export * from "./Costing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports